const BlankChart = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_206_1631)">
      <path
        d="M10.7233 2.19336H11.7235C12.1214 2.19336 12.5031 2.35143 12.7844 2.63279C13.0658 2.91416 13.2239 3.29577 13.2239 3.69369V13.6959C13.2239 14.0938 13.0658 14.4754 12.7844 14.7568C12.5031 15.0381 12.1214 15.1962 11.7235 15.1962H4.72201C4.32409 15.1962 3.94248 15.0381 3.66112 14.7568C3.37975 14.4754 3.22168 14.0938 3.22168 13.6959V3.69369C3.22168 3.29577 3.37975 2.91416 3.66112 2.63279C3.94248 2.35143 4.32409 2.19336 4.72201 2.19336H5.72222"
        stroke="currentColor"
        strokeWidth="1.00189"
        strokeLinejoin="round"
      />
      <path
        d="M9.90663 1.1925H6.53854C6.0874 1.1925 5.72168 1.55822 5.72168 2.00936V2.37637C5.72168 2.82751 6.0874 3.19323 6.53854 3.19323H9.90663C10.3578 3.19323 10.7235 2.82751 10.7235 2.37637V2.00936C10.7235 1.55822 10.3578 1.1925 9.90663 1.1925Z"
        stroke="currentColor"
        strokeWidth="1.00189"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_206_1631">
        <rect
          width="16.0035"
          height="16.0035"
          fill="white"
          transform="translate(0.220703 0.192993)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default BlankChart;
